import { About } from './About/About';

import { Hero } from './Hero/Hero';

export const App = () => {
  return (
    <div>
      <Hero />
      <About />
      {/* <BurgerMenu /> */}
    </div>
  );
};
